import { render } from "./WorkHero.vue?vue&type=template&id=29df093b"
import script from "./WorkHero.vue?vue&type=script&lang=js"
export * from "./WorkHero.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__